import { apiClient } from "../client";
import {
  GoldPriceApiResponse,
  GoldPriceHistoryApiResponse,
  GoldPriceHistoryReq
} from "./gold-price.type";

const gold_price_endpoint = "/ecom-frontend/v3/get-gold-price";
const gold_price_history_endpoint = "/ecom-frontend/v1/get-gold-price-history";

export const GOLD_PRICE_DATA_KEY = "gold-price";
export const GOLD_HISTORY_DATA_KEY = "gold-price-history";
// Get current gold price (API 1)
export const fetchGoldPrice = async (): Promise<GoldPriceApiResponse> =>
  await apiClient.get(`${gold_price_endpoint}`);

// Get gold price history (API 2)
export const fetchGoldPriceHistory = async ({
  date
}: GoldPriceHistoryReq): Promise<GoldPriceHistoryApiResponse> =>
  await apiClient.get(`${gold_price_history_endpoint}?date=${date}`);
